<div *ngIf="countries?.length !== 0">
  <mat-form-field>
    <mat-select
      [placeholder]="required ? 'Country *' : 'Country'"
      [formControl]="country"
    >
      <mat-option *ngFor="let country of countries" [value]="country.value">
        {{ country.label }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="country.errors">Country is required</mat-error>
  </mat-form-field>
</div>
<div *ngIf="states?.length !== 0">
  <mat-form-field>
    <mat-select
      [placeholder]="required ? 'State *' : 'State'"
      [formControl]="state"
    >
      <mat-option *ngFor="let s of states" [value]="s.value">
        {{ s.label }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="state.errors">State is required</mat-error>
  </mat-form-field>
</div>
